export default __webpack_public_path__ + "static/media/excel-primary.9db8f3ce.svg";